import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {FormFields} from 'types/utils';
import {request} from 'utils/request';

import {UserDetailsFormFields} from '../types';

export type UserDetailsFormData = FormFields<UserDetailsFormFields>;

export type CreateUserDetailsSuccessResponse = Api.Response.Success<
    Record<string, unknown>
>;

export type CreateUserDetailsErrorResponse = Api.Response.Failure<
    keyof UserDetailsFormFields
>;

export const usePostUserDetails = (): UseMutationResult<
    CreateUserDetailsSuccessResponse,
    CreateUserDetailsErrorResponse,
    UserDetailsFormData
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            uri: '/api/signup/validate/',
        }),
    );
};
